/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgRoadsideService32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={32}
      fill='none'
      viewBox='0 0 48 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M29.702 3v3.5h.002v7h-.002v3.75h-4.62l-1.266-4.565 2.318-.58-.364-1.455-23.995 6L0 17.08l.354 1.458 1.09-.265v6.977H4.89a4.255 4.255 0 004.063 3 4.255 4.255 0 004.063-3h1.874a4.255 4.255 0 004.063 3 4.255 4.255 0 004.063-3h11.874a4.255 4.255 0 004.063 3 4.255 4.255 0 004.063-3h4.687v-5.18a6.784 6.784 0 00-3.01-5.638l-1.246-.835.008-.012-.883-.578-3.097-8.257h-8.272V3h-1.5zm13.493 20.75h3.007v-3.68c0-1.764-.88-3.41-2.344-4.392l-2.322-1.554v-.001l-.198-.13-2.903-7.743h-7.23v6.5h6.303v-.71a.29.29 0 00-.29-.29h-.766v-1.5h.767a1.79 1.79 0 011.79 1.79v3.46h-1.5v-1.25h-6.307v9.5h3.507c.13-2.228 1.981-4 4.243-4a4.253 4.253 0 014.243 4zm-20 0h6.507v-5H2.944v5h1.765c.13-2.228 1.981-4 4.243-4a4.253 4.253 0 014.243 4h1.514c.13-2.228 1.981-4 4.243-4a4.253 4.253 0 014.243 4zM6.202 24a2.753 2.753 0 002.75 2.75 2.753 2.753 0 002.75-2.75 2.753 2.753 0 00-2.75-2.75A2.753 2.753 0 006.202 24zM22.36 13.05l1.165 4.2H5.558l16.802-4.2zM16.202 24a2.753 2.753 0 012.75-2.75 2.753 2.753 0 012.75 2.75 2.753 2.753 0 01-2.75 2.75 2.753 2.753 0 01-2.75-2.75zm20 0a2.753 2.753 0 012.75-2.75 2.753 2.753 0 012.75 2.75 2.753 2.753 0 01-2.75 2.75 2.753 2.753 0 01-2.75-2.75z'
      />
    </svg>
  );
}

export default SvgRoadsideService32;
